/**
 * Statuset e rekrutimit — një burim i vetëm.
 *
 * Të njëjtat gjashtë vlera ishin shkruar në KATËR skedarë: `ApplicationsList`,
 * `ApplicationForm`, `RecruitmentFunnel` dhe `InterviewsPage`. Dhe jo njësoj —
 * «Listë e shkurtër» te dy prej tyre, «Në listë» te i treti, «Në listë të
 * shkurtër» te i katërti. I njëjti status dukej si tre gjëra të ndryshme, dhe
 * shtimi i një faze do të kërkonte katër ndryshime pa e ditur askush ku.
 *
 * `key` është vlera që RUHET te `applications.status`. Ajo nuk ndryshon: te
 * baza ka rreshta me këto vlera, dhe një riemërtim do të ishte migrim.
 * Etiketat janë vetëm për ekran.
 *
 * Renditja këtu është renditja e gypit. «Rejected» rri e fundit sepse është
 * dalje, jo hap i radhës — por në këtë fazë ajo mbetet vetëm renditje, jo
 * rregull: kalimet e lejuara janë punë e Fazës 2.
 */
export const RECRUITMENT_STATUSES = [
  { key: 'applied',     label: 'Aplikuar',         short: 'Aplikuar',   color: 'default', tone: '#64748B' },
  { key: 'shortlisted', label: 'Listë e shkurtër', short: 'Në listë',   color: 'info',    tone: '#0284C7' },
  { key: 'interview',   label: 'Intervistë',       short: 'Intervistë', color: 'info',    tone: '#2563EB' },
  { key: 'offer',       label: 'Ofertë',           short: 'Ofertë',     color: 'warning', tone: '#B45309' },
  { key: 'hired',       label: 'Punësuar',         short: 'Punësuar',   color: 'success', tone: '#15803D' },
  { key: 'rejected',    label: 'Refuzuar',         short: 'Refuzuar',   color: 'error',   tone: '#B91C1C' },
];

/** Çelësat, në rendin e gypit. */
export const RECRUITMENT_STATUS_KEYS = RECRUITMENT_STATUSES.map((s) => s.key);

/** Fazat pas aplikimit — numëruesit e ekraneve që nisin nga lista e shkurtër. */
export const PIPELINE_STATUS_KEYS = RECRUITMENT_STATUS_KEYS.filter((k) => k !== 'applied');

/** Daljet: kandidati nuk vazhdon. Përdoret nga numëruesit, jo si ndalesë. */
export const CLOSED_STATUS_KEYS = ['hired', 'rejected'];

const BY_KEY = Object.fromEntries(RECRUITMENT_STATUSES.map((s) => [s.key, s]));

/**
 * Përkufizimi i një statusi. Një vlerë e panjohur — p.sh. e shkruar me dorë te
 * baza para se lista të mbyllej — kthehet si është, jo bosh.
 */
export const statusMeta = (key) =>
  BY_KEY[key] || { key, label: key || '—', short: key || '—', color: 'default', tone: '#64748B' };

export const statusLabel = (key) => statusMeta(key).label;
export const statusColor = (key) => statusMeta(key).color;

/** Për `<Select>`: `{ value, label }`, forma që pret MUI. */
export const STATUS_OPTIONS = RECRUITMENT_STATUSES.map((s) => ({ value: s.key, label: s.label }));

export default RECRUITMENT_STATUSES;
